<template>
    <div class="co-documento-signatario-novo">
        <span class="mr-1">Tipo de documento</span>
        <icon-info :descricao-campo="descricaoCampo"/>
        <v-select
            v-model="value.documentoId"
            v-validate="validarCampo()"
            class="required-field ml-1 mt-0 pt-0 select-documentos"
            :error-messages="errors.collect('Documento')"
            :items="documentos"
            name="Documento"
            placeholder="Selecione"
            persistent-placeholder
            :rules="[(v) => !!v || 'Informe o campo obrigatório']"
            filled
            attach
            hide-details
            :menu-props="{ minWidth: '210' }"
        />
    </div>
</template>

<script>
import IconInfo from '@/views/criar-documento/novo-documento-signatario/components/IconInfo'

export default {
    name: 'DocumentoSignatarioNovo',
    components: {IconInfo},
    props: {
        value: {
            required: true
        },
        campoRequerido: {
            type: Boolean,
            default: false
        },
        descricao: {
            type: Boolean
        },
        documentos: {
            required: true,
            type: Array,
            default: () => []
        }
    },
    data: () => ({
        documentosSelecao: []
    }),
    computed: {
        descricaoCampo() {
            return `Tipo de documento que o ${this.$tc("pt_br.signatario").toLowerCase()} informará no momento da assinatura.`
        },
    },
    methods: {
        validarCampo() {
            return this.campoRequerido ? 'required' : ''
        }
    }
}
</script>

<style lang="stylus">
.co-documento-signatario-novo
    position relative
    width 100%
    display flex
    align-items center

    .select-documentos
        font-size 12px
        max-width 240px

        .v-select__slot
            height 20px

    .v-text-field.v-text-field--enclosed:not(.v-text-field--rounded) > .v-input__control > .v-input__slot
        min-height 20px

    .v-text-field.v-text-field--enclosed .v-text-field__details, .v-text-field.v-text-field--enclosed:not(.v-text-field--rounded) > .v-input__control > .v-input__slot
        padding 4px

    .v-text-field--enclosed .v-input__append-inner
        margin 0px
        padding 0
</style>
